<template>
  <div v-if="loading || xml"
    style="display: flex; flex-direction: column; justify-content: center; align-items: center">
    <div class="pt-4 pb-4">
      <button @click="downloadXml()" class="btn btn-primary btn-sm">
        <span class="pr-1">
          Tải file XML
        </span>
        <i class="fal fa-download"></i>
      </button>
    </div>
    <div >
      <pre style="text-align: left; 
        max-width: 750px;  
        overflow: scroll; 
        max-height: 65vh;
        position: absolute;
        top: 1;
        word-wrap: break-word; 
        right: 0;
        left: 0;
        ">
       {{ prettifyXml }}
    </pre>
    </div>
  </div>
</template>

<script>

const formatXml = (sourceXml) => {
  const xmlDoc = new DOMParser().parseFromString(sourceXml, 'application/xml');
  const xsltDoc = new DOMParser().parseFromString([
    // describes how we want to modify the XML - indent everything
    '<xsl:stylesheet xmlns:xsl="http://www.w3.org/1999/XSL/Transform">',
    '  <xsl:strip-space elements="*"/>',
    '  <xsl:template match="para[content-style][not(text())]">', // change to just text() to strip space in text nodes
    '    <xsl:value-of select="normalize-space(.)"/>',
    '  </xsl:template>',
    '  <xsl:template match="node()|@*">',
    '    <xsl:copy><xsl:apply-templates select="node()|@*"/></xsl:copy>',
    '  </xsl:template>',
    '  <xsl:output indent="yes"/>',
    '</xsl:stylesheet>',
  ].join('\n'), 'application/xml');

  const xsltProcessor = new XSLTProcessor();
  xsltProcessor.importStylesheet(xsltDoc);
  const resultDoc = xsltProcessor.transformToDocument(xmlDoc);
  const resultXml = new XMLSerializer().serializeToString(resultDoc);
  return resultXml;
};

export default {
  name: 'InvoiceXmlViewer',
  components: {},
  props: {
    xml: String,
    loading: Boolean,
  },
  data() {
    return {
      prettifyXml: '',
    };
  },
  mounted() {
    this.prettifyXml = formatXml(this.xml);
  },
  computed: {
  },
  methods: {
    downloadXml() {
      const element = document.createElement('a');
      const xmlContent = encodeURIComponent(this.xml.replace(/<\?xml-stylesheet(([^?>])+)\?>/, ''));
      element.setAttribute('href', `data:text/plain;charset=utf-8,${xmlContent}`);
      element.setAttribute('download', 'invoice.xml');
      element.style.display = 'none';
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/portal-components/invoice/invoice-xml-viewer.vue